var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.568726,
    width: 25.05,
    height: 24,
    fill: "url(#pattern0_457_293)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_457_293",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_457_293",
    transform: "matrix(0.01 0 0 0.0104375 0 -0.021875)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_457_293",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAhlJREFUeAHtm9GpwlAYxs4gbuAuLuqQyr9AG7CGWlPok+F+ktwKfThrdWUgAxnIQAYykIEMZCADGcgAMXBbaz137mG6JAP3tdZr5x6mSzJQEEk0nSkINSVxBZFE05mCUFMSVxBJNJ0pCDUlcQWRRNOZglBTElcQSTSdKQg1JXEFkUTTmYJQUxJXEEk0nSkINSVxBZFE05mCUFMSVxBJNJ0pCDUlcQWRRNOZglBTElcQSTSdKQg1JXEFkUTTmYJQUxJXEEk0nSkINSVxBZFE05mCUFMSVxBJNJ0pCDUlcQWRRNOZglBTElcQSTSdKQg1JXF/HWQOT46AM92PnfOFc/5wmDN95/kuhxxEndOuewcs+5w5GpcfXwVhssk/ZUFO9nQXpCDHPd7kJ+DXmJ6QnpCekK2ntifkik9IL4bHvWAe8mL48YvMF/7AvPVu/TTMZ8N0SQYKIommMwWhpiSuIJJoOlMQakriCiKJpjMFoaYkriCSaDpTEGpK4goiiaYzBaGmJK4gkmg6UxBqSuIKIommMwWhpiSuIJJoOlMQakriCiKJpjMFoaYkriCSaDpTEGpK4goiiaYzBaGmJK4gkmg6UxBqSuIKIommMwWhpiSuIJJoOlMQakriCiKJpjMFoaYkriCSaDpTEGpK4goiiaYzBaGmJK4gkmg6M4cn54jx1n3ZA5ZUUlwGMpCBDGQgAxnIQAYykAFi4A0/EyNEPIqvwgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.2aee173c023f9167e166c0630b7f3505.svg";
export { ForwardRef as ReactComponent };